import { useContext } from "react";
import { MdMenu, MdTravelExplore } from "react-icons/md";
import { AppContext } from "../App";
import { company, navigationItems } from "../siteContent";

export default function TopBar(props) {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  return (
    <div className="TopBar">
      <div className="body">
        <div className="container d-flex justify-content-between align-items-center h-100">
          <div className="align-self-center d-flex align-items-center topbar-brand-wrap">
            <MdMenu className="align-self-center mMobileOnly topbar-menu-trigger" size={32} onClick={appContext.openSideBar} />

            <img
              src={company.logo}
              alt={company.shortName}
              className="align-self-center topbar-logo rounded-pill"
              onClick={() => {
                appContext.navTo({ item: "home" });
              }}
            />

            <div className="topbar-brand-copy mDesktopOnly">
              <h6 className="mNoMargin font-bold text-primary">{company.shortName}</h6>
              <p className="mNoMargin font-light text-dark">{company.tagline}</p>
            </div>

            <div className="topbar-brand-copy-mobile mMobileOnly">
              <h6 className="mNoMargin font-bold text-primary">Zanzibar Mission Tours</h6>
              <p className="mNoMargin font-light text-dark">Zanzibar, Tanzania</p>
            </div>
          </div>

          <div className="DesktopMenu align-self-center mNoMargin mNoPadding">
            {navigationItems.slice(0, 3).map((nav) => (
              <div
                key={nav.item}
                className="mMenuItem"
                data-active={appContext.navItem === nav.item || (!appContext.navItem && nav.item === "home")}
                onClick={() => goTo(nav.item)}
              >
                {nav.label}
              </div>
            ))}
            <div className="mMenuItem">
              <button className="btn btn-primary btn-rounded btn-padded" onClick={() => goTo("contact_us")}>
                <MdTravelExplore size={20} className="me-2" />
                Start Planning
              </button>
            </div>
          </div>

          <div className="align-self-center mNoMargin mNoPadding mMobileOnly">
            <button className="btn btn-secondary btn-rounded topbar-mobile-cta" onClick={() => goTo("contact_us")}>
              Plan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
